<template>
    <v-layout>
        <v-flex xs12>
            <v-card>
                <v-layout>
                    <v-flex xs12>
                        <h1 class="text-xs-center">Details</h1>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex xs12>
                        <v-layout row wrap>
                            <v-flex xs12 md4 :class="{'formSpacing':$vuetify.breakpoint.mdAndUp}">
                                <v-select
                                    :items="stores"
                                    item-text="Name"
                                    item-value="ID"
                                    v-model="order.StoreID"
                                    label="Store"
                                    hint="Store"
                                    readonly
                                ></v-select>
                            </v-flex>
                            <v-flex xs12 md4 :class="{'formSpacing':$vuetify.breakpoint.mdAndUp}">
                                <v-select
                                    :items="departmentsInSelectedStore"
                                    item-text="Name"
                                    item-value="ID"
                                    v-model="order.DepartmentID"
                                    label="Department"
                                    hint="Department"
                                    no-data-text="No departments for this store"
                                    readonly
                                ></v-select>
                            </v-flex>
                            <v-flex xs12 md4 :class="{'formSpacing':$vuetify.breakpoint.mdAndUp}">
                                <v-text-field
                                    slot="activator"
                                    v-model="order.Date"
                                    label="Order Date"
                                    prepend-icon="event"
                                    hint="Order Date"
                                    readonly
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card>
            <v-card>
                <v-layout>
                    <v-flex xs12>
                        <h1 class="text-xs-center">Items</h1>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex xs12>
                            <v-data-table
                                :headers="headers"
                                :items="orderProductsAndComments"
                                hide-actions
                                must-sort
                                :pagination.sync="pagination"
                            >
                                <template slot="items" slot-scope="props">
                                    <tr >
                                        <td>{{ props.item.Category.Name }}</td>
                                        <td>                                 
                                            {{ props.item.Product.Name }}
                                             <v-icon  v-if="props.item.Product.Comments" middle color="green" @click="showOrderProductsComments(props.item.Product)">comment</v-icon>
                                        </td>
                                         <!-- add comment icon view only -->
                                        <td>{{ props.item.Supplier ? props.item.Supplier.Name : "" }}</td>
                                        <td>{{ props.item.Quantity ?  props.item.Quantity : "" }}</td>
                                        <td>{{ props.item.Stock ?  props.item.Stock : "" }}</td>
                                        <td></td>
                                    </tr>
                                </template>
                                <template slot="no-data">
                                    <v-alert outline :value="true" type="info">
                                        Item list is empty.
                                    </v-alert>
                                </template>
                            </v-data-table>
                    </v-flex>
                </v-layout>
            </v-card>
            <v-card>
                <v-layout wrap class="dialog-action-buttons">
                    <v-flex xs12 md6>
                        <v-btn block color="error" @click="goBack">Modify Order</v-btn>
                    </v-flex>
                    <v-flex xs12 md6>
                        <v-btn block color="success" :loading="confirming" @click="confirmOrder">Confirm Order</v-btn>
                    </v-flex>
                    <v-flex xs12>
                        <error-alert :content="confirmError" :display="confirmError"></error-alert>
                    </v-flex>
                </v-layout>   
            </v-card>                         
        </v-flex>
            <v-dialog v-model="commentDialog" max-width="400">
                <v-card class="no-padding">
                    <v-container>
                    <v-layout>
                        <v-flex>
                            <label class="v-label v-label--active theme--light comment-label">Comments</label>
                            <div>{{productComment}}</div>
                        </v-flex>
                    </v-layout>
                    </v-container>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red" flat="flat" @click="commentDialog = false">Cancel</v-btn>
                    </v-card-actions>
                </v-card>
        </v-dialog>
    </v-layout>
    
</template>

<script>
import validationRules from "../../helpers/validationrules";
import ErrorAlert from "../common/ErrorAlert";
import auth from '@/services/auth';
import util from '@/services/util';

export default {
    components: {
        ErrorAlert
    },
    props: [
        'loading',
        'confirming',
        'confirmError',
        'showStockEntry'
    ],
    data() {
        return {
            show: false,
            commentDialog: false,
            productComment: null,
            pagination: {
                sortBy: "Category.SortOrder",
                rowsPerPage: -1
            },
            headers: [
                {
                    text: "Category",
                    value: "Category.Name",
                    width: "25%"
                },
                {
                    text: "Product",
                    value: "Product.Name",
                    width: "25%"
                },
                {
                    text: "Supplier",
                    value: "Supplier.Name",
                    width: "25%"
                },
                {
                    text: "Quantity",
                    value: "Quantity",
                    width: "15%"
                },
          
            ]
        };
    },
    computed: {
        order(){
            return this.$store.state.placeOrderStore.order;
        },
        orderProducts(){
            return this.$store.state.placeOrderStore.orderProducts;
        },
        orderProductsAndComments() {
            return this.$store.getters["placeOrderStore/getOrderProductsAndComments"];
        },
        stores() {
            return this.$store.state.storeStore.stores.filter(s => s.Active && auth.hasAccessToStore(s.ID)).sort(util.sortByName);
        },
        departments() {
            return this.$store.state.departmentStore.departments.filter(d => d.Active && auth.hasAccessToDepartment(d.ID)).sort(util.sortByName);
        },
        departmentsInSelectedStore(){
            let selectedStoreID = this.order.StoreID;

            return this.departments.filter(d => {
                if(!selectedStoreID){
                    return false;
                }

                let selectedStore = this.stores.find(s => s.ID == selectedStoreID);
                if(!selectedStore.DepartmentIDs){
                    return false;
                }
                
                let selectedStoreContainsDepartment = selectedStore.DepartmentIDs.split(",").some(dID => dID == d.ID);
                if(!selectedStoreContainsDepartment){
                    return false;
                }

                return true;
            });
        },
        selectedDepartment(){
            return this.departmentsInSelectedStore.find(d => d.ID == this.order.DepartmentID);
        },
    },
    methods: {
        goBack(){
            this.$emit("onCancel");
        },
        confirmOrder() {
            this.$emit("onConfirm");
        },
        showOrderProductsComments(product) {
            this.commentDialog = true;
            this.productComment = product.Comments;
        },
        checkDepartment(){
            if(this.showStockEntry==true || this.selectedDepartment.Name=="Organics"){
                this.headers.push({
                    text: "Stock",
                    value: "Stock",
                    width: "15%",           
                })
        }
        }
    },
    created(){
        this.checkDepartment();
    }
};
</script>

<style>
.product-name {
    min-width: 150px;
}
.comment-label {
    font-size: 12px;
}
</style>
